import { render } from "./Home.vue?vue&type=template&id=07ce5e9a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=07ce5e9a&lang=less"
script.render = render

export default script